import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios";
import { apiRoot } from "..";
import { Spinner } from "react-bootstrap";

const NewsAdd = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [inputs, setInputs] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);

  const addNewsItemMutation = useMutation((newsItem) => {
    return axios.post(apiRoot  + '/news', newsItem);
  },
  {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetchNews']);
      navigate("/aktuality");
    },
    onError: (error) => {
      setErrorMessage(error.message); // TODO json -> errorCode -> hlaska
      window.scrollTo(0, 0);
    }
  });

  const handleChange = (event) => {
    if (!addNewsItemMutation.isLoading) {
      const name = event.target.name;
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage(null);

    if (!inputs.header || !inputs.content) { // TODO trim
      setErrorMessage('Některé povinné položky nejsou vyplněné.');
      window.scrollTo(0, 0);
      // TODO zvyrazneni nevyplnenych vstupnich poli
      return;
    }

    addNewsItemMutation.mutate(inputs);
  }

  return (
    <>
<div>
<span className="align-middle">
<i className="fa fa-exclamation-circle fa-3x fa-in-header align-middle" aria-hidden="true"></i>
<h2 className="d-inline-block align-middle">Přidat aktualitu</h2>
</span>
</div>

<form onSubmit={handleSubmit}>

<table>
<tbody>
<tr>
<td>{errorMessage && <div className="alert alert-danger" role="alert">{errorMessage}</div>}</td>
</tr><tr>
<td><strong>Titulek:</strong></td>
</tr><tr>
<td><input type="text" className="form-control" name="header" size="70" value={inputs.header || ""} onChange={handleChange} /></td>
</tr><tr>
<td><strong>Obsah:</strong> <em>(umožňuje formátování pomocí <a href="http://www.edgering.org/markdown/" target="_blank" rel="noreferrer">Markdown značek</a>)</em></td>
</tr><tr>
<td><textarea className="form-control" name="content" cols="80" rows="40" value={inputs.content || ""} onChange={handleChange} /></td>
</tr><tr>
<td><button type="submit" className="btn btn-success" disabled={addNewsItemMutation.isLoading}><i className="fa fa-plus" aria-hidden="true"></i> Přidat aktualitu</button>
{addNewsItemMutation.isLoading ? (<> <Spinner as="span" animation="border" size="sm" /></>) : (<></>)}</td>
</tr>
</tbody>
</table>

</form>
    </>
  );
};

export default NewsAdd;